import { injectable } from 'inversify'

export type TelemetryProperties = Record<string, unknown>

/**
 * No real analytics backend exists for this project — track() just logs, so
 * the call sites (and the convention: what gets tracked, with what shape of
 * properties) exist and are demonstrable now, ready to swap the inside of
 * this one method for a real sink later without touching any caller.
 */
@injectable()
export class TelemetryGateway {
  track(event: string, properties?: TelemetryProperties): void {
    console.info(`[telemetry] ${event}`, properties ?? '')
  }
}
